// extracted by mini-css-extract-plugin
export var indeterminate = "_27-6";
export var md = "_27-5";
export var semantic = "_27-7";
export var sm = "_27-4";
export var text = "_27-8";
export var toggleControl = "_27-0";
export var toggleInput = "_27-1";
export var toggleSwitch = "_27-2";
export var xs = "_27-3";